<template>
  <header
    class="flex flex-col items-center justify-between max-w-full md:max-w-6xl px-2 md:px-6 pb-12 mx-auto sm:flex-row"
  >
    <router-link to="/" class="text-indigo-900 z-10 active order-last sm:order-first hidden md:block">
      <img src="@/assets/BlankLogo.svg" class="w-12 md:py-0 g-image" />
    </router-link>
    <nav class="z-10 order-first sm:order-last">
      <Social />
    </nav>
  </header>
</template>
<script>
export default {
  name: "HeaderComponent",
  components: {
    Social: () => import("./Social.vue"),
  },
};
</script>
